export default "__VITE_ASSET__hts1obkF__"